import { createFileRoute } from "@tanstack/react-router"
import type { ReactElement } from "react"
import { AdminScheduledPostList } from "~/components/Admin/AdminScheduledPostList"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"
import CustomHead from "~/components/SEOHead/CustomHead"
import { AixContentHeader } from "@aix/ui"

function AdminScheduledPostsPage() {
  return (
    <>
      <CustomHead />
      <div className="container mx-auto space-y-6">
        <AixContentHeader className="px-8 pt-8">
          <h1 className="text-2xl font-bold">Scheduled Posts</h1>
          <p className="text-muted-foreground">Manage and monitor all scheduled video posts across platforms</p>
        </AixContentHeader>
        <AdminScheduledPostList />
      </div>
    </>
  )
}

function AdminScheduledPostsPageWrapper() {
  return (
    <SuperAdminLayout>
      <AdminScheduledPostsPage />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/scheduledPosts")({
  component: AdminScheduledPostsPageWrapper,
})
